// filepath: c:\Users\vprea\GitHub\kasam\frontend\src\i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import EditAccountPage from './pages/account/EditAccountPage';

const resources = {
    en: {
        translation: {
            editFoundPetPage: {
                title: 'Edit Found Pet',
                locationFound: 'Location Found',
                petType: 'Pet Type',
                dateFound: 'Date Found',
                timeFound: 'Time Found',
                description: 'Description',
                outcome: 'Outcome',
                locationLeft: 'Location Left',
                phoneNumber: 'Phone Number',
                name: 'Name',
                email: 'Email',
                manageToken: 'Manage Token',
                update: 'Update Found Pet',
                updating: 'Updating...',
                delete: 'Delete Found Pet',
                deleting: 'Deleting...',
                leftOnPlace: 'Left on the place',
                enterAddress: 'Enter address or search on map',
                enterPhone: 'Enter phone number',
                enterManageToken: 'Enter your manage token',
                success: 'Found pet updated successfully!',
                error: 'Error updating found pet.',
                errorDelete: 'Error deleting found pet.',
                confirmDelete: 'Are you sure you want to delete this found pet?',
                loading: 'Loading...',
            },
            reportFoundPetPage: {
                title: 'Report a Found Pet',
                petType: 'Pet Type',
                locationFound: 'Location Found',
                dateFound: 'Date Found',
                timeFound: 'Time Found',
                description: 'Description',
                images: 'Images',
                outcome: 'Outcome',
                locationLeft: 'Location Left',
                next: 'Next',
                back: 'Back',
                contactInfo: 'Contact Info',
                name: 'Name',
                email: 'Email',
                phoneNumber: 'Phone Number',
                reporting: 'Reporting...',
                reportFoundPet: 'Report Found Pet',
                pleaseFillAll: 'Please fill all required fields.',
                pleaseProvideLeftLocation: 'Please provide the location where the pet was left.',
                errorReporting: 'Error reporting found pet.',
                success: 'Found pet reported successfully!',
                loadingMap: 'Loading map...',
                loadingUserData: 'Loading user data...',
                selectPetType: 'Select pet type',
                selectOutcome: 'Select outcome',
                leftOnPlace: 'Left on the place',
                enterAddress: 'Enter address or search on map',
                enterPhone: 'Enter phone number',
            },
            foundPetDetailsPage: {
                petType: 'Type',
                contactInfo: 'Contact Finder',
                foundDetails: 'Found Details',
                foundOn: 'Found on:',
                outcome: 'Outcome:',
                description: 'Description:',
                noDescription: 'No description provided.',
                foundAt: 'Found at:',
                leftAt: 'Left at:',
                noFoundDetails: 'No found details available.',
                edit: 'Edit',
                whatsappMessage: 'I want to contact because I have found your pet',
                foundPetInquirySubject: 'Found Pet Inquiry',
                foundPetInquiryBody: 'I would like to inquire about your found pet.',
                images: 'Images',
                map: 'Map',
                info: 'Info',
                lostPetSuggestions: 'Lost Pet Suggestions Nearby',
                noSuggestions: 'No lost pets found nearby.',
                viewDetails: 'View Details',
                lastSeen: 'Last seen',
            },
            manageFoundPetImagesPage: {
                title: 'Found Pictures',
                imageAlt: 'Found Image {{index}}',
                uploadTitle: 'Upload Found Pictures',
                uploadButton: 'Upload',
                uploading: 'Uploading...',
                previewAlt: 'Preview Found Image {{index}}',
            },
            signup: {
                title: 'Signup',
                name: 'Name',
                email: 'Email',
                password: 'Password',
                language: 'Preferred Language',
                submit: 'Sign up',
                loading: 'Signing up...',
                success: 'Signup successful! You can now log in.',
                alreadyRegistered: 'Already Registered?',
                loginHere: 'Log in here',
            },
            login: {
                title: 'Log In',
                emailLabel: 'Email',
                emailPlaceholder: 'Enter your email',
                passwordLabel: 'Password',
                passwordPlaceholder: 'Enter your password',
                loginButton: 'Log in',
                googleLoginButton: 'Login with Google',
                error: 'Error',
                signupPrompt: 'Not Registered Yet?',
                signupLink: 'Sign up here',
            },
            navbar: {
                logo: 'DaFauna',
                foundPets: 'Found Pets',
                lostPets: 'Lost Pets',
                myAccount: 'My Account',
                settings: 'Settings',
                login: 'Login',
            },
            accountPage: {
                title: 'Account',
                editTitle: 'Edit Account',
                name: 'Name',
                email: 'Email',
                countryCode: 'Country Code',
                phoneNumber: 'Phone Number',
                language:'Language',
                editButton: 'Edit User',
                logoutButton: 'Log out',
                loading: 'Loading...',
                error: 'Error',
                userNotFound: 'User not found.',
            },
            editAccountPage: {
                userUpdated: 'Account updated successfully!',
            },
            settingsPage: {
                title: 'Settings',
                titleEdit: 'Edit Settings',
                preferredLanguage: 'Preferred Language',
                updating: 'Updating...',
                updateAccount: 'Update Account',
                editButton: 'Edit Settings',
                updateSuccess: 'Settings updated successfully!',
                updateError: 'Failed to update settings.',
                fetchError: 'Failed to fetch data.',
            },
            home: {
                fetchedOrganizationsLog: 'Fetched Organizations:',
                fetchErrorLog: 'Error fetching organizations:',
                fetchError: 'Failed to fetch organizations.',
                loading: 'Loading organizations...',
                error: 'Error',
                greeting: 'Hi, {{name}}!',
                noOrganizationsMessage: 'Add your Ball of Fur and invite your family!',
            },
            organizationList: {
                title: 'Your Families',
                fetchErrorLog: 'Error fetching pets:',
                familyOfOne: 'Family of {{pet}}',
                familyOfTwo: 'Family of {{pet1}} and {{pet2}}',
                familyOfMany: 'Family of {{pets}} and {{lastPet}}',
                noPets: 'No pets in this organization',
            },
            organizationPage: {
                title: 'Organization Members',
                name: 'Name',
                email: 'Email',
                role: 'Role',
                invite: 'Invite',
                saveChanges: 'Save Changes',
                saving: 'Saving...',
                fetchError: 'Failed to fetch members.',
                rolesUpdated: 'Roles updated successfully!',
                updateError: 'Failed to update roles.',
                loading: 'Loading...',
            },
            organizationInvitationPage: {
                title: 'Invite a Family Member',
                emailLabel: 'Email Address',
                emailPlaceholder: 'Enter the email address',
                roleLabel: 'Role',
                inviting: 'Inviting...',
                inviteButton: 'Invite Member',
                successMessage: 'User invited successfully!',
                errorMessage: 'Failed to invite user.',
            },
            petList: {
                title: 'Your Buddies! 🐶🐱🐇🦜',
                noImage: 'No image available',
                addPet: 'Add',
            },
            createPetPage: {
                titleFirstPetOrg: 'Add your Buddy and create your Family',
                titleAnyPetOrg: 'Add your Best Friend!',
                successMessage: 'Pet added successfully!',
                errorMessage: 'Error adding pet',
            },
            editPetPage: {
                title: 'Edit your Buddy',
            },
            weightHistoryPage: {
                title: 'Weight History',
                chartLabel: 'Weight (kg)',
                noData: 'No weight history available.',
                update: 'Update',
                cancel: 'Cancel',
                weightPlaceholder: 'Weight (kg)',
                addButton: 'Add',
                date: 'Date',
                weight: 'Weight (kg)',
                noEntries: 'No weight entries available.',
                addFailed: 'Failed to add weight entry.',
            },
            condition: {
                titleEdit: 'Edit Condition',
                titleEditTreatment: 'Edit Treatment',
                hasDisability: 'Does the pet have an disability?',
                hasAllergy: 'Does the pet have an allergy?',
                hasDisease: 'Does the pet have a disease?',
                disabilityName: 'Disability Name',
                allergyName: 'Allergy Name',
                diseaseName: 'Disease Name',
                diagnosisDate: 'Diagnosis Date',
                diagnosisDatePlaceholder: 'Select diagnosis date',
                notes: 'Notes',
                notesPlaceholder: 'Enter notes',
                allergyTreatment: 'Does the allergy have a treatment?',
                disabilityTreatment: 'Does the disability have a treatment?',
                diseaseTreatment: 'Does the disease have a treatment?',
                treatmentName: 'Treatment Name',
                lastGivenDate: 'Last Given Date',
                recurrence: 'Recurrence',
                endDate: 'End Date',
                addAllergy: 'Add Allergy',
                allergies: 'Allergies',
                allergyNamePlaceholder: 'Enter allergy name',
                noAllergies: 'No allergies available.',
                addDisability: 'Add Disability',
                disabilities: 'Disabilities',
                disabilityNamePlaceholder: 'Enter disability name',
                noDisabilities: 'No disabilities available.',
                addDisease: 'Add Disease',
                diseases: 'Diseases',
                diseaseNamePlaceholder: 'Enter disease name',
                noDiseases: 'No diseases available.',
                fetchFailed: 'Failed to fetch condition details.',
                updateFailed: 'Failed to update condition.',
                deleteFailed: 'Failed to delete condition.',
                fetchFailed: 'Failed to fetch treatment details.',
                updateFailed: 'Failed to update treatment.',
                deleteFailed: 'Failed to delete treatment.',
                recovered: 'Recovered',
                isRecovered: 'Is Recovered?',
                recoveryDate: 'Recovery Date',
                confirmRecovery: 'Confirm Recovery',
                recoveryDatePlaceholder: 'Enter recovery date',
                treatments: 'Treatments',
                treatmentName: 'Name',
                treatmentNamePlaceholder: 'Enter treatment name',
                lastGivenDate: 'Last Given Date',
                lastGivenDatePlaceholder: 'Enter last given date',
                selectRecurrence: 'Select Recurrence',
                endDatePlaceholder: 'Enter end date',
                titleEditTreatment: 'Edit Treatment',
                pauseTreatment: 'Pause Treatment',
                activateTreatment: 'Activate Treatment',
                noHistory: 'No history available for this treatment.',
                noTreatments: 'No treatments available for this condition.',
            },
            allergy: {
                title: 'Add New Allergy',
                createButton: 'Create Allergy',
                createFailed: 'Failed to create Allergy.',
                missingAllergyId: 'Allergy ID is missing in the response.',
            },
            disability: {
                title: 'Add New Disability',
                createButton: 'Create Disability',
                createFailed: 'Failed to create Disability.',
                missingDisabilityId: 'Disability ID is missing in the response.',
            },
            disease: {
                title: 'Add New Disease',
                createButton: 'Create Disease',
                createFailed: 'Failed to create Disease.',
                missingDiseaseId: 'Disease ID is missing in the response.',
            },
            general: {
                noAuthToken: 'No authentication token found.',
                back: 'Back',
                next: 'Next',
                adding: 'Adding...',
                add: 'Add',
                finish: 'Finish',
                save: 'Save',
                cancel: 'Cancel',
                update: 'Update',
                loading: 'Loading...',
                delete: 'Delete',
                deleting: 'Deleting...',
                selectOption: 'Select',
                unknown: 'Unknown',
                yes: 'Yes',
                no: 'No',
                name: 'Name',
                method: 'Method',
                type: 'Type',
                status: 'Status',
                lastOne: 'Last One',
                nextOne: 'Next One',
                end: 'End',
                recurrence: 'Recurrence',
                na: 'N/A',
                updating: 'Updating...',
                markAsGiven: 'Mark as Given',
                confirmGiven: 'Confirm Given',
                confirm: 'Confirm',
                history: 'History',
                date: 'Date',
                action: 'Action',
                noNotes: 'No notes',
                hide: 'Hide',
                view: 'View',
                year: 'Years',
                month: 'Months',
                day: 'Days',
                edit: 'Edit',
            },
            deworming: {
                title: 'Add New Deworming',
                titleEdit: 'Edit Deworming',
                method: 'Deworming Method',
                selectMethod: 'Select Method',
                customMethod: 'Custom Method',
                enterCustomMethod: 'Enter custom method',
                type: 'Deworming Type',
                selectType: 'Select Type',
                lastGivenDate: 'Last Given Date',
                selectLastGivenDate: 'Select last given date',
                recurrence: 'Recurrence',
                selectRecurrence: 'Select Recurrence',
                endDate: 'End Date',
                selectEndDate: 'Select end date',
                add: 'Add Deworming',
                other: 'Other',
                fetchFailed: 'Failed to fetch deworming details.',
                updateFailed: 'Failed to update deworming.',
                updateFailedStatus: 'Failed to update deworming status.',
                markGivenFailed: 'Failed to mark deworming as given.',
                deleteFailed: 'Failed to delete deworming.',
                updating: 'Updating...',
                update: 'Update Deworming',
                deleting: 'Deleting...',
                delete: 'Delete Deworming',
                pause: 'Pause Deworming',
                activate: 'Activate Deworming',
                noHistory: 'No history available for this deworming.',
            },
            vaccine: {
                title: 'Add New Vaccine',
                titleEdit: 'Edit Vaccine',
                vaccineName: 'Vaccine Name',
                vaccinePlaceholder: 'Select vaccine(s)',
                otherOption: 'Other',
                otherName: 'Other Vaccine Name',
                otherNameLabel: 'Other Vaccine Name',
                otherNamePlaceholder: 'Enter vaccine name',
                lastGivenDate: 'Last Given Date',
                lastGivenDatePlaceholder: 'Select last given date',
                recurrence: 'Recurrence',
                recurrencePlaceholder: 'Select Recurrence',
                endDate: 'End Date',
                endDatePlaceholder: 'Select end date',
                addButton: 'Add Vaccine',
                createFailed: 'Failed to create vaccine.',
                missingVaccineId: 'Vaccine ID is missing in the response.',
                fetchFailed: 'Failed to fetch vaccine details.',
                updateFailed: 'Failed to update vaccine.',
                updateFailedStatus: 'Failed to update vaccine status.',
                markGivenFailed: 'Failed to mark vaccine as given.',
                deleteFailed: 'Failed to delete vaccine.',
                updateButton: 'Update Vaccine',
                deleteButton: 'Delete Vaccine',
                updating: 'Updating...',
                deleting: 'Deleting...',
                pause: 'Pause Vaccine',
                activate: 'Activate Vaccine',
                noHistory: 'No history available for this vaccine.',
            },
            generalPet: {
                general: 'General',
                deletePet: 'Delete Pet',
                step1Title: 'Step 1: Pet Name, Sex, and Description',
                step2Title: 'Step 2: General Info',
                step3Title: 'Step 3: Behavior',
                step4Title: 'Step 4: Health Information',
                viewLostPetDetails: 'View Lost Pet Details',
                reportAsLost: 'Report as Lost',
                nameRequired: 'Name is required',
                typeRequired: 'Pet Type is required',
                genderRequired: 'Gender is required',
                birthDateRequired: 'Birth Date is required',
                breedRequired: 'Breed Selection is required',
                furRequired: 'Fur Amount and Fur Length are required when Has Fur is Yes',
                imageAvailable: 'No image available',
                petName: 'Pet Name',
                petType: 'Pet Type',
                gender: 'Gender',
                birthDate: 'Birth Date',
                noDescription: 'No description available.',
                breed: 'Breed',
                isMixedBreed: 'Is Mixed Breed?',
                breedSelection: 'Breed Selection',
                selectBreedsOrUnknown: 'Select Breeds or Unknown',
                selectBreedOrUnknown: 'Select Breed or Unknown',
                size: 'Size',
                fur: 'Fur',
                hasFur: 'Has Fur',
                noFur: 'No Fur',
                furAmount: 'Fur Amount',
                furLength: 'Fur Length',
                selectAmount: 'Select Amount',
                selectLength: 'Select Length',
                color: 'Color',
                primaryColor: 'Primary Color',
                secondaryColors: 'Secondary Colors',
                selectColor: 'Select Color',
                eyeColors: 'Eye Colors',
                behaviorWithPeople: 'Behavior with People',
                behaviorWithDogs: 'Behavior with Dogs',
                behaviorWithCats: 'Behavior with Cats',
                behaviorWith: 'Behavior With',
                withPeople: 'People',
                withDogs: 'Dogs',
                withCats: 'Cats',
                castrated: 'Castrated',
                isCastrated: 'Is the pet castrated?',
                hasChip: 'Does the pet have a chip?',
                chip: 'Chip',
                chipNumber: 'Chip Number',
                noChip: 'No Chip Available',
                noChipNumber: 'No Chip Number Available',
                tattoo: 'Tattoo',
                hasTattoo: 'Does the pet have a tattoo?',
                vaccines: 'Vaccines',
                noVaccines: 'No vaccines available.',
                dewormings: 'Dewormings',
                noDewormings: 'No dewormings available.',
                weight: 'Weight',
                fetchError: 'Error fetching pet data.',
                furRequired: 'Fur Amount and Fur Length are required when Has Fur is Yes',
                successMessageEdit: 'Pet updated successfully!',
                errorMessageEdit: 'Error updating pet',
                description: 'Description',
                picturesOfYourBuddy: 'Pictures of your Buddy',
                generalImageAlt: 'General Image',
                noPicturesAvailable: 'No pictures available for this pet.',
                lostPictures: 'Lost Pictures',
                lostImageAlt: 'Lost Image',
            },
            updateProfileImagePage: {
                title: 'Update Profile Picture',
                successMessage: 'Profile picture updated successfully. Redirecting...',
                currentImageAlt: 'Current Profile Picture',
                deleteButton: 'Delete',
                selectNewImage: 'Select New Picture',
                updateButton: 'Update',
                cancelButton: 'Cancel',
            },
            managePetImagesPage: {
                title: 'Manage Images for {{name}}',
                imageAlt: 'Image {{index}}',
                uploadTitle: 'Upload New Images',
                uploadButton: 'Upload',
                uploading: 'Uploading...',
                previewAlt: 'Preview Image {{index}}',
            },
            manageLostPetImagesPage: {
                title: 'Lost Pictures of {{name}}',
                imageAlt: 'Lost Image {{index}}',
                uploadTitle: 'Upload Lost Pictures',
                uploadButton: 'Upload',
                uploading: 'Uploading...',
                previewAlt: 'Preview Lost Image {{index}}',
            },
            error: {
                noAuthToken: 'No token found. Please log in again.',
                loadPetData: 'Failed to load pet data.',
                selectImage: 'Please select an image to upload.',
                uploadImage: 'Failed to upload the image.',
                noImageToDelete: 'No image to delete.',
                deleteImage: 'Failed to delete the image.',
            },
            reportPetLostPage: {
                title: 'Report Your Pet as Lost',
                dateLost: 'Date lost',
                timeLost: 'Time lost',
                loadingMap: 'Loading map...',
                address: 'Address or place',
                addressPlaceholder: 'Type or select an address',
                additionalPictures: 'Additional lost pictures',
                previewAlt: 'Preview Image {{index}}',
                description: 'Description (optional)',
                next: 'Next',
                back: 'Back',
                submit: 'Report as Lost',
                submitting: 'Submitting your report...',
                contactInfo: 'Contact Information',
                email: 'Email:',
                countryCode: 'Country Code:',
                countryCodePlaceholder: 'Country Code',
                phoneNumber: 'Phone Number:',
                phoneNumberPlaceholder: 'Phone Number',
                error: {
                    noLocation: 'Please provide a valid location.',
                    submitFailed: 'Failed to report pet as lost.',
                    generalError: 'An error occurred while reporting your pet.',
                    mapLoadFailed: 'Map failed to load.',
                    fetchUserDetails: 'Failed to fetch user details.',
                },
            },
            lostPetDetailsPage: {
                petTypeAndAge: '{{petType}} - {{age}}',
                contactInfo: 'Contact Info',
                lostDetails: 'Lost Details',
                lostOn: 'Lost On:',
                description: 'Description:',
                noDescription: 'No description provided',
                noLostDetails: 'No lost details available.',
                reportFound: 'Report Found',
                whatsappMessage: 'I want to contact because I have seen your pet',
                lostPetInquirySubject: 'Lost Pet Inquiry',
                lostPetInquiryBody: 'I would like to inquire about your lost pet.',
                foundPetSuggestions: 'Found Pet Suggestions Nearby',
                noSuggestions: 'No found pets nearby.',
                viewDetails: 'View Details',
                foundOn: 'Found on',
            },
            reportLostPetFoundPage: {
                title: 'Congrats! Give us some details ♥️',
                error: 'Please provide all required information.',
                success: 'Congrats! 🎊 Your buddy was found! Redirecting...',
                dateFoundLabel: 'Date found',
                timeFoundLabel: 'Time found',
                locationFoundLabel: 'Location found',
                locationPlaceholder: 'Type or select an address',
                confirmButton: 'Confirm',
                mapLoading: 'Loading map...',
                mapError: 'Map failed to load',
            },
            lostPetsPage: {
                daysLost: "Lost {{count}} day/s ago",
                viewMyPet: "View My Pet",
                viewDetails: "View Details",
                title: "Lost Pets",
                searchLocationPlaceholder: "Search location",
                dateRange: "Date Range",
                selectDateRange: "Select Date Range",
                petType: "Pet Type",
                selectPetType: "Select Pet Type",
                clearFilters: "Clear Filters",
                listView: "List View",
                mapView: "Map View",
                lastDay: "Last Day",
                last10Days: "Last 10 Days",
                lastMonth: "Last Month",
                lastQuarter: "Last Quarter",
                lastYear: "Last Year",
                hideFilters: "Hide Filters",
                showFilters: "Show Filters",
                loading: "Loading...",
                errorFetching: "Error fetching lost pets",
            },
            foundPetsPage: {
                title: "Found Pets",
                reportFoundPet: "Pet Found",
                daysFound: "Found {{count}} day/s ago",
                showOnlyMyPets: "Show only my reported pets",
            },
            generalPet: {
                general: 'General',
                description: 'Description',
                viewLostPetDetails: 'View Lost Pet Details',
                reportAsLost: 'Report as Lost',
                picturesOfYourBuddy: 'Pictures of your Buddy',
                noPicturesAvailable: 'No pictures available.',
                lostPictures: 'Lost Pictures',
                step1Title: 'Step 1: Pet Name, Sex, and Description',
                step2Title: 'Step 2: General Info',
                step3Title: 'Step 3: Behavior',
                step4Title: 'Step 4: Health Information',
                nameRequired: 'Name is required',
                typeRequired: 'Pet Type is required',
                genderRequired: 'Gender is required',
                birthDateRequired: 'Birth Date is required',
                breedRequired: 'Breed Selection is required',
                furRequired: 'Fur Amount and Fur Length are required when Has Fur is Yes',
                imageAvailable: 'No image available',
                petName: 'Pet Name',
                petType: 'Pet Type',
                gender: 'Gender',
                birthDate: 'Birth Date',
                noDescription: 'No description available.',
                breed: 'Breed',
                isMixedBreed: 'Is Mixed Breed?',
                breedSelection: 'Breed Selection',
                selectBreedsOrUnknown: 'Select Breeds or Unknown',
                selectBreedOrUnknown: 'Select Breed or Unknown',
                size: 'Size',
                fur: 'Fur',
                hasFur: 'Has Fur',
                noFur: 'No Fur',
                furAmount: 'Fur Amount',
                furLength: 'Fur Length',
                selectAmount: 'Select Amount',
                selectLength: 'Select Length',
                color: 'Color',
                primaryColor: 'Primary Color',
                secondaryColors: 'Secondary Colors',
                selectColor: 'Select Color',
                eyeColors: 'Eye Colors',
                behaviorWithPeople: 'Behavior with People',
                behaviorWithDogs: 'Behavior with Dogs',
                behaviorWithCats: 'Behavior with Cats',
                behaviorWith: 'Behavior With',
                withPeople: 'People',
                withDogs: 'Dogs',
                withCats: 'Cats',
                castrated: 'Castrated',
                isCastrated: 'Is the pet castrated?',
                hasChip: 'Does the pet have a chip?',
                chip: 'Chip',
                chipNumber: 'Chip Number',
                noChip: 'No Chip Available',
                noChipNumber: 'No Chip Number Available',
                tattoo: 'Tattoo',
                hasTattoo: 'Does the pet have a tattoo?',
                vaccines: 'Vaccines',
                noVaccines: 'No vaccines available.',
                dewormings: 'Dewormings',
                noDewormings: 'No dewormings available.',
                weight: 'Weight',
                fetchError: 'Error fetching pet data.',
                furRequired: 'Fur Amount and Fur Length are required when Has Fur is Yes',
                successMessageEdit: 'Pet updated successfully!',
                errorMessageEdit: 'Error updating pet',
                imageAvailable: "No image available",
                unknown: "Unknown",
            },
        },
    },
    es: {
        translation: {
            editFoundPetPage: {
                title: 'Editar Mascota Encontrada',
                locationFound: 'Lugar donde se encontró',
                petType: 'Tipo de Mascota',
                dateFound: 'Fecha de Encuentro',
                timeFound: 'Hora de Encuentro',
                description: 'Descripción',
                outcome: 'Resultado',
                locationLeft: 'Lugar donde se dejó',
                phoneNumber: 'Número de Teléfono',
                name: 'Nombre',
                email: 'Correo Electrónico',
                manageToken: 'Token de Gestión',
                update: 'Actualizar Mascota Encontrada',
                updating: 'Actualizando...',
                delete: 'Eliminar Mascota Encontrada',
                deleting: 'Eliminando...',
                leftOnPlace: 'Dejado en el lugar',
                enterAddress: 'Escribe o selecciona una dirección',
                enterPhone: 'Introduce el número de teléfono',
                enterManageToken: 'Introduce tu token de gestión',
                success: '¡Mascota encontrada actualizada con éxito!',
                error: 'Error al actualizar la mascota encontrada.',
                errorDelete: 'Error al eliminar la mascota encontrada.',
                confirmDelete: '¿Estás seguro de que deseas eliminar esta mascota encontrada?',
                loading: 'Cargando...',
            },
            foundPetDetailsPage: {
                petType: 'Tipo',
                contactInfo: 'Contacto del Encontrador',
                foundDetails: 'Detalles de Encuentro',
                foundOn: 'Encontrado el:',
                outcome: 'Resultado:',
                description: 'Descripción:',
                noDescription: 'No se proporcionó descripción.',
                foundAt: 'Encontrado en:',
                leftAt: 'Dejado en:',
                noFoundDetails: 'No hay detalles de encuentro disponibles.',
                edit: 'Editar',
                whatsappMessage: 'Quiero contactar porque he encontrado tu mascota',
                foundPetInquirySubject: 'Consulta sobre Mascota Encontrada',
                foundPetInquiryBody: 'Me gustaría preguntar sobre tu mascota encontrada.',
                images: 'Imágenes',
                map: 'Mapa',
                info: 'Info',
                lostPetSuggestions: 'Sugerencias de Mascotas Perdidas Cercanas',
                noSuggestions: 'No se encontraron mascotas perdidas cercanas.',
                viewDetails: 'Ver Detalles',
                lastSeen: 'Visto por última vez',
            },
            manageFoundPetImagesPage: {
                title: 'Imágenes encontradas',
                imageAlt: 'Imagen Encontrada {{index}}',
                uploadTitle: 'Subir Imágenes Encontradas',
                uploadButton: 'Subir',
                uploading: 'Cargando...',
                previewAlt: 'Vista Previa de Imagen Encontrada {{index}}',
            },
            reportFoundPetPage: {
                title: 'Reportar una Mascota Encontrada',
                petType: 'Tipo de Mascota',
                locationFound: 'Lugar Encontrado',
                dateFound: 'Fecha Encontrada',
                timeFound: 'Hora Encontrada',
                description: 'Descripción',
                images: 'Imágenes',
                outcome: 'Resultado',
                locationLeft: 'Lugar Donde se Dejó',
                next: 'Siguiente',
                back: 'Atrás',
                contactInfo: 'Información de Contacto',
                name: 'Nombre',
                email: 'Correo Electrónico',
                phoneNumber: 'Número de Teléfono',
                reporting: 'Reportando...',
                reportFoundPet: 'Reportar Mascota Encontrada',
                pleaseFillAll: 'Por favor, complete todos los campos requeridos.',
                pleaseProvideLeftLocation: 'Por favor, proporcione el lugar donde se dejó la mascota.',
                errorReporting: 'Error al reportar la mascota encontrada.',
                success: '¡Mascota encontrada reportada con éxito!',
                loadingMap: 'Cargando mapa...',
                loadingUserData: 'Cargando datos del usuario...',
                selectPetType: 'Seleccionar tipo de mascota',
                selectOutcome: 'Seleccionar resultado',
                leftOnPlace: 'Dejado en el lugar',
                enterAddress: 'Ingrese dirección o busque en el mapa',
                enterPhone: 'Ingrese número de teléfono',
            },
            signup: {
                title: 'Registro',
                name: 'Nombre',
                email: 'Correo Electrónico',
                password: 'Contraseña',
                language: 'Idioma Preferido',
                submit: 'Registrarse',
                loading: 'Registrando...',
                success: '¡Registro exitoso! Ahora puedes iniciar sesión.',
                alreadyRegistered: '¿Ya estás registrado?',
                loginHere: 'Inicia sesión aquí',
            },
            login: {
                title: 'Iniciar Sesión',
                emailLabel: 'Correo Electrónico',
                emailPlaceholder: 'Ingrese su correo electrónico',
                passwordLabel: 'Contraseña',
                passwordPlaceholder: 'Ingrese su contraseña',
                loginButton: 'Iniciar sesión',
                googleLoginButton: 'Iniciar sesión con Google',
                error: 'Error',
                signupPrompt: '¿No estás registrado?',
                signupLink: 'Regístrate aquí',
            },
            navbar: {
                logo: 'DaFauna',
                foundPets: 'Mascotas Encontradas',
                lostPets: 'Mascotas Perdidas',
                myAccount: 'Mi Cuenta',
                settings: 'Configuración',
                login: 'Iniciar Sesión',
            },
            accountPage: {
                title: 'Cuenta',
                editTitle: 'Editar Cuenta',
                name: 'Nombre',
                email: 'Correo Electrónico',
                countryCode: 'Código de País',
                phoneNumber: 'Número de Teléfono',
                language:'idioma',
                editButton: 'Editar Usuario',
                logoutButton: 'Cerrar Sesión',
                loading: 'Cargando...',
                error: 'Error',
                userNotFound: 'Usuario no encontrado.',
            },
            editAccountPage: {
                userUpdated: 'Cuenta actualizada con éxito!',
            },
            settingsPage: {
                title: 'Configuración',
                titleEdit: 'Editar Configuración',
                preferredLanguage: 'Idioma Preferido',
                updating: 'Actualizando...',
                updateAccount: 'Actualizar Cuenta',
                editButton: 'Editar Configuración',
                updateSuccess: 'Configuración actualizados con éxito!',
                updateError: 'Error al actualizar la configuración.',
                fetchError: 'Error al obtener los datos.',
            },
            home: {
                fetchedOrganizationsLog: 'Organizaciones obtenidas:',
                fetchErrorLog: 'Error al obtener organizaciones:',
                fetchError: 'Error al obtener organizaciones.',
                loading: 'Cargando organizaciones...',
                error: 'Error',
                greeting: 'Hola, {{name}}!',
                noOrganizationsMessage: '¡Agrega tu Pelud@ e invita a tu familia!',
            },
            organizationList: {
                title: 'Tus Familias',
                fetchErrorLog: 'Error al obtener mascotas:',
                familyOfOne: 'Familia de {{pet}}',
                familyOfTwo: 'Familia de {{pet1}} y {{pet2}}',
                familyOfMany: 'Familia de {{pets}} y {{lastPet}}',
                noPets: 'No hay mascotas en esta organización',
            },
            organizationPage: {
                title: 'Miembros de la Organización',
                name: 'Nombre',
                email: 'Correo Electrónico',
                role: 'Rol',
                invite: 'Invitar',
                saveChanges: 'Guardar Cambios',
                saving: 'Guardando...',
                fetchError: 'Error al obtener los miembros.',
                rolesUpdated: '¡Roles actualizados con éxito!',
                updateError: 'Error al actualizar los roles.',
                loading: 'Cargando...',
            },
            organizationInvitationPage: {
                title: 'Invitar a un Miembro de la Familia',
                emailLabel: 'Dirección de Correo Electrónico',
                emailPlaceholder: 'Ingrese la dirección de correo electrónico',
                roleLabel: 'Rol',
                inviting: 'Invitando...',
                inviteButton: 'Invitar Miembro',
                successMessage: '¡Usuario invitado con éxito!',
                errorMessage: 'Error al invitar al usuario.',
            },
            petList: {
                title: '¡Tus Pelud@s! 🐶🐱🐇🦜',
                noImage: 'No hay imagen disponible',
                addPet: 'Agregar',
            },
            createPetPage: {
                titleFirstPetOrg: 'Agrega a tu Compañero y crea tu Familia',
                titleAnyPetOrg: '¡Agrega a tu Mejor Amigo!',
                successMessage: '¡Mascota agregada con éxito!',
                errorMessage: 'Error al agregar la mascota',
            },
            editPetPage: {
                title: 'Edita a tu Compañero',
            },
            weightHistoryPage: {
                title: 'Historial de Peso',
                chartLabel: 'Peso (kg)',
                noData: 'No hay historial de peso disponible.',
                update: 'Actualizar',
                cancel: 'Cancelar',
                weightPlaceholder: 'Peso (kg)',
                addButton: 'Agregar',
                date: 'Fecha',
                weight: 'Peso (kg)',
                noEntries: 'No hay entradas de peso disponibles.',
                addFailed: 'Error al agregar la entrada de peso.',
            },
            condition: {
                titleEdit: 'Editar Condición',
                titleEditTreatment: 'Editar Tratamiento',
                hasDisability: '¿Tiene la mascota una discapacidad?',
                hasAllergy: '¿Tiene la mascota una alergia?',
                hasDisease: '¿Tiene la mascota una enfermedad?',
                disabilityName: 'Nombre de la Discapacidad',
                allergyName: 'Nombre de la Alergia',
                diseaseName: 'Nombre de la Enfermedad',
                diagnosisDate: 'Fecha de Diagnóstico',
                diagnosisDatePlaceholder: 'Seleccione la fecha de diagnóstico',
                notes: 'Notas',
                notesPlaceholder: 'Ingrese notas',
                allergyTreatment: '¿La alergia tiene un tratamiento?',
                disabilityTreatment: '¿La discapacidad tiene un tratamiento?',
                diseaseTreatment: '¿La enfermedad tiene un tratamiento?',
                treatmentName: 'Nombre del Tratamiento',
                lastGivenDate: 'Última Fecha Administrada',
                recurrence: 'Recurrencia',
                endDate: 'Fecha de Finalización',
                addAllergy: 'Agregar Alergia',
                allergies: 'Alergias',
                allergyNamePlaceholder: 'Ingrese el nombre de la alergia',
                noAllergies: 'No hay alergias disponibles.',
                addDisability: 'Agregar Discapacidad',
                disabilities: 'Discapacidades',
                disabilityNamePlaceholder: 'Ingrese el nombre de la discapacidad',
                noDisabilities: 'No hay discapacidades disponibles.',
                addDisease: 'Agregar Enfermedad',
                diseases: 'Enfermedades',
                diseaseNamePlaceholder: 'Ingrese el nombre de la enfermedad',
                noDiseases: 'No hay enfermedades disponibles.',
                fetchFailed: 'Error al obtener los detalles de la condición.',
                updateFailed: 'Error al actualizar la condición.',
                deleteFailed: 'Error al eliminar la condición.',
                recovered: 'Recuperado',
                isRecovered: '¿Está Recuperado?',
                recoveryDate: 'Fecha de Recuperación',
                confirmRecovery: 'Confirmar Recuperación',
                recoveryDatePlaceholder: 'Ingrese la fecha de recuperación',
                treatments: 'Tratamientos',
                treatmentName: 'Nombre',
                treatmentNamePlaceholder: 'Ingrese el nombre del tratamiento',
                lastGivenDate: 'Última Fecha Administrada',
                lastGivenDatePlaceholder: 'Ingrese la última fecha administrada',
                selectRecurrence: 'Seleccione la Recurrencia',
                endDatePlaceholder: 'Ingrese la fecha de finalización',
                titleEditTreatment: 'Editar Tratamiento',
                pauseTreatment: 'Pausar Tratamiento',
                activateTreatment: 'Activar Tratamiento',
                noHistory: 'No hay historial disponible para este tratamiento.',
                noTreatments: 'No hay tratamientos disponibles para esta condición.',
            },
            allergy: {
                title: 'Agregar Nueva Alergia',
                createButton: 'Crear Alergia',
                createFailed: 'Error al crear la alergia.',
                missingAllergyId: 'Falta el ID de la alergia en la respuesta.',
            },
            disability: {
                title: 'Agregar Nueva Discapacidad',
                createButton: 'Crear Discapacidad',
                createFailed: 'Error al crear la discapacidad.',
                missingDisabilityId: 'Falta el ID de la discapacidad en la respuesta.',
            },
            disease: {
                title: 'Agregar Nueva Enfermedad',
                createButton: 'Crear Enfermedad',
                createFailed: 'Error al crear la enfermedad.',
                missingDiseaseId: 'Falta el ID de la enfermedad en la respuesta.',
            },
            general: {
                noAuthToken: 'No se encontró un token de autenticación.',
                back: 'Atrás',
                next: 'Siguiente',
                adding: 'Agregando...',
                add: 'Agregar',
                finish: 'Finalizar',
                save: 'Guardar',
                cancel: 'Cancelar',
                update: 'Actualizar',
                loading: 'Cargando...',
                delete: 'Eliminar',
                deleting: 'Eliminando...',
                selectOption: 'Seleccionar',
                unknown: 'Desconocido',
                yes: 'Sí',
                no: 'No',
                name: 'Nombre',
                method: 'Método',
                type: 'Tipo',
                status: 'Estado',
                lastOne: 'Último',
                nextOne: 'Siguiente',
                end: 'Fin',
                recurrence: 'Recurrencia',
                na: 'N/A',
                updating: 'Actualizando...',
                markAsGiven: 'Marcar como Administrado',
                confirmGiven: 'Confirmar Administrado',
                confirm: 'Confirmar',
                history: 'Historial',
                date: 'Fecha',
                action: 'Acción',
                noNotes: 'Sin notas',
                hide: 'Ocultar',
                view: 'Ver',
                year: 'Años',
                month: 'Meses',
                day: 'Días',
                edit: 'Editar',
            },
            deworming: {
                title: 'Agregar Nueva Desparasitación',
                titleEdit: 'Editar Desparasitación',
                method: 'Método de Desparasitación',
                selectMethod: 'Seleccionar Método',
                customMethod: 'Método Personalizado',
                enterCustomMethod: 'Ingrese método personalizado',
                type: 'Tipo de Desparasitación',
                selectType: 'Seleccionar Tipo',
                lastGivenDate: 'Última Fecha Administrada',
                selectLastGivenDate: 'Seleccionar última fecha administrada',
                recurrence: 'Recurrencia',
                selectRecurrence: 'Seleccionar Recurrencia',
                endDate: 'Fecha de Finalización',
                selectEndDate: 'Seleccionar fecha de finalización',
                add: 'Agregar Desparasitación',
                other: 'Otro',
                fetchFailed: 'Error al obtener los detalles de la desparasitación.',
                updateFailed: 'Error al actualizar la desparasitación.',
                updateFailedStatus: 'Error al actualizar el estado de la desparasitación.',
                markGivenFailed: 'Error al marcar la desparasitación como administrada.',
                deleteFailed: 'Error al eliminar la desparasitación.',
                updating: 'Actualizando...',
                update: 'Actualizar Desparasitación',
                deleting: 'Eliminando...',
                delete: 'Eliminar Desparasitación',
                pause: 'Pausar Desparasitación',
                activate: 'Activar Desparasitación',
                noHistory: 'No hay historial disponible para esta desparasitación.',
            },
            vaccine: {
                title: 'Agregar Nueva Vacuna',
                titleEdit: 'Editar Vacuna',
                vaccineName: 'Nombre de la Vacuna',
                vaccinePlaceholder: 'Seleccionar vacuna(s)',
                otherOption: 'Otra',
                otherName: 'Nombre de Otra Vacuna',
                otherNameLabel: 'Nombre de Otra Vacuna',
                otherNamePlaceholder: 'Ingrese el nombre de la vacuna',
                lastGivenDate: 'Última Fecha Administrada',
                lastGivenDatePlaceholder: 'Seleccionar última fecha administrada',
                recurrence: 'Recurrencia',
                recurrencePlaceholder: 'Seleccionar Recurrencia',
                endDate: 'Fecha de Finalización',
                endDatePlaceholder: 'Seleccionar fecha de finalización',
                addButton: 'Agregar Vacuna',
                createFailed: 'Error al crear la vacuna.',
                missingVaccineId: 'Falta el ID de la vacuna en la respuesta.',
                fetchFailed: 'Error al obtener los detalles de la vacuna.',
                updateFailed: 'Error al actualizar la vacuna.',
                updateFailedStatus: 'Error al actualizar el estado de la vacuna.',
                markGivenFailed: 'Error al marcar la vacuna como administrada.',
                deleteFailed: 'Error al eliminar la vacuna.',
                updateButton: 'Actualizar Vacuna',
                deleteButton: 'Eliminar Vacuna',
                updating: 'Actualizando...',
                deleting: 'Eliminando...',
                pause: 'Pausar Vacuna',
                activate: 'Activar Vacuna',
                noHistory: 'No hay historial disponible para esta vacuna.',
            },
            generalPet: {
                general: 'General',
                deletePet: 'Eliminar Mascota',
                description: 'Descripción',
                viewLostPetDetails: 'Ver Detalles de Mascota Perdida',
                reportAsLost: 'Reportar como Perdida',
                picturesOfYourBuddy: 'Imágenes de tu Compañero',
                noPicturesAvailable: 'No hay imágenes disponibles.',
                lostPictures: 'Imágenes Perdidas',
                step1Title: 'Paso 1: Nombre, Sexo y Descripción de la Mascota',
                step2Title: 'Paso 2: Información General',
                step3Title: 'Paso 3: Comportamiento',
                step4Title: 'Paso 4: Información de Salud',
                viewLostPetDetails: 'Ver Detalles de Mascota Perdida',
                reportAsLost: 'Reportar como Perdida',
                nameRequired: 'El nombre es obligatorio',
                typeRequired: 'El tipo de mascota es obligatorio',
                genderRequired: 'El género es obligatorio',
                birthDateRequired: 'La fecha de nacimiento es obligatoria',
                breedRequired: 'La selección de raza es obligatoria',
                furRequired: 'La cantidad y longitud del pelaje son obligatorias cuando tiene pelaje',
                imageAvailable: 'No hay imagen disponible',
                petName: 'Nombre de la Mascota',
                petType: 'Tipo de Mascota',
                gender: 'Género',
                birthDate: 'Fecha de Nacimiento',
                noDescription: 'No hay descripción disponible.',
                breed: 'Raza',
                isMixedBreed: '¿Es de raza mixta?',
                breedSelection: 'Selección de Raza',
                selectBreedsOrUnknown: 'Seleccionar Razas o Desconocido',
                selectBreedOrUnknown: 'Seleccionar Raza o Desconocido',
                size: 'Tamaño',
                fur: 'Pelaje',
                hasFur: '¿Tiene pelaje?',
                noFur: 'Sin Pelaje',
                furAmount: 'Cantidad de Pelaje',
                furLength: 'Longitud del Pelaje',
                selectAmount: 'Seleccionar Cantidad',
                selectLength: 'Seleccionar Longitud',
                color: 'Color',
                primaryColor: 'Color Principal',
                secondaryColors: 'Colores Secundarios',
                selectColor: 'Seleccionar Color',
                eyeColors: 'Colores de Ojos',
                behaviorWithPeople: 'Comportamiento con Personas',
                behaviorWithDogs: 'Comportamiento con Perros',
                behaviorWithCats: 'Comportamiento con Gatos',
                behaviorWith: 'Comportamiento Con',
                withPeople: 'Personas',
                withDogs: 'Perros',
                withCats: 'Gatos',
                castrated: 'Castrado',
                isCastrated: '¿Está castrado el animal?',
                hasChip: '¿Tiene chip el animal?',
                chip: 'Chip',
                chipNumber: 'Número de Chip',
                noChip: 'No hay chip disponible',
                noChipNumber: 'No hay número de chip disponible',
                tattoo: 'Tatuaje',
                hasTattoo: '¿Tiene tatuaje el animal?',
                vaccines: 'Vacunas',
                noVaccines: 'No hay vacunas disponibles.',
                dewormings: 'Desparasitaciones',
                noDewormings: 'No hay desparasitaciones disponibles.',
                weight: 'Peso',
                fetchError: 'Error al obtener los datos de la mascota.',
                furRequired: 'La cantidad y longitud del pelaje son obligatorias cuando tiene pelaje',
                successMessageEdit: '¡Mascota actualizada con éxito!',
                errorMessageEdit: 'Error al actualizar la mascota',
                description: 'Descripción',
                picturesOfYourBuddy: 'Imagenes de tu Compañer@',
                generalImageAlt: 'Imagen General',
                noPicturesAvailable: 'No hay imágenes disponibles para esta mascota.',
                lostPictures: 'Imágenes Perdidas',
                lostImageAlt: 'Imagen Perdida',
            },
            updateProfileImagePage: {
                title: 'Actualizar Imagen de Perfil',
                successMessage: 'Imagen de perfil actualizada con éxito. Redirigiendo...',
                currentImageAlt: 'Imagen de Perfil Actual',
                deleteButton: 'Eliminar',
                selectNewImage: 'Seleccionar Nueva Imagen',
                updateButton: 'Actualizar',
                cancelButton: 'Cancel',
            },
            managePetImagesPage: {
                title: 'Administrar Imágenes de {{name}}',
                imageAlt: 'Imagen {{index}}',
                uploadTitle: 'Subir Nuevas Imágenes',
                uploadButton: 'Subir',
                uploading: 'Cargando...',
                previewAlt: 'Vista Previa de Imagen {{index}}',
            },
            manageLostPetImagesPage: {
                title: 'Imágenes de {{name}}',
                imageAlt: 'Imagen Perdida {{index}}',
                uploadTitle: 'Subir Imágenes',
                uploadButton: 'Subir',
                uploading: 'Cargando...',
                previewAlt: 'Vista Previa de Imagen Perdida {{index}}',
            },
            error: {
                noAuthToken: 'No se encontró el token. Por favor, inicie sesión nuevamente.',
                loadPetData: 'Error al cargar los datos de la mascota.',
                selectImage: 'Por favor, seleccione una imagen para subir.',
                uploadImage: 'Error al subir la imagen.',
                noImageToDelete: 'No hay imagen para eliminar.',
                deleteImage: 'Error al eliminar la imagen.',
            },
            reportPetLostPage: {
                title: 'Informa a tu Mascota como Perdida',
                dateLost: 'Fecha de pérdida',
                timeLost: 'Hora de pérdida',
                loadingMap: 'Cargando mapa...',
                address: 'Dirección o lugar',
                addressPlaceholder: 'Escribe o selecciona una dirección',
                additionalPictures: 'Imágenes adicionales de la pérdida',
                previewAlt: 'Vista previa de la imagen {{index}}',
                description: 'Descripción (opcional)',
                next: 'Siguiente',
                back: 'Atrás',
                submit: 'Reportar como Perdida',
                submitting: 'Enviando tu reporte...',
                contactInfo: 'Información de Contacto',
                email: 'Email:',
                countryCode: 'Código de País:',
                countryCodePlaceholder: 'Código de País',
                phoneNumber: 'Número de Teléfono:',
                phoneNumberPlaceholder: 'Número de Teléfono',
                error: {
                    noLocation: 'Por favor, proporciona una ubicación válida.',
                    submitFailed: 'Error al reportar la mascota como perdida.',
                    generalError: 'Ocurrió un error al reportar tu mascota.',
                    mapLoadFailed: 'Error al cargar el mapa.',
                    fetchUserDetails: 'Error al obtener los detalles del usuario.',
                },
            },
            lostPetDetailsPage: {
                petTypeAndAge: '{{petType}} - {{age}}',
                contactInfo: 'Contacto',
                lostDetails: 'Detalles',
                lostOn: 'Perdido el:',
                description: 'Descripción:',
                noDescription: 'No se proporcionó descripción',
                noLostDetails: 'No hay detalles perdidos disponibles.',
                reportFound: 'Encontrado',
                whatsappMessage: 'Quiero contactar porque he visto tu mascota',
                lostPetInquirySubject: 'Consulta sobre Mascota Perdida',
                lostPetInquiryBody: 'Me gustaría preguntar sobre tu mascota perdida.',
                foundPetSuggestions: 'Mascotas encontradas cerca',
                noSuggestions: 'No hay mascotas encontradas cerca.',
                viewDetails: 'Ver detalles',
                foundOn: 'Encontrado el',
            },
            reportLostPetFoundPage: {
                title: 'Felicidades! Danos detalles ♥️',
                error: 'Por favor, proporciona toda la información requerida.',
                success: 'Felicidades! 🎊 ¡Tu compañero fue encontrado! Redirigiendo...',
                dateFoundLabel: 'Fecha de encontrado',
                timeFoundLabel: 'Hora de encontrado',
                locationFoundLabel: 'Donde fue encontrado',
                locationPlaceholder: 'Escribe o selecciona una dirección',
                confirmButton: 'Confirmar',
                mapLoading: 'Cargando mapa...',
                mapError: 'Error al cargar el mapa',
            },
            lostPetsPage: {
                daysLost: "Desapareció hace {{count}} día/s",
                viewMyPet: "Ver mi mascota",
                viewDetails: "Ver detalles",
                title: "Mascotas perdidas",
                searchLocationPlaceholder: "Buscar ubicación",
                dateRange: "Rango de fechas",
                selectDateRange: "Seleccionar rango de fechas",
                petType: "Tipo de mascota",
                selectPetType: "Seleccionar tipo de mascota",
                clearFilters: "Limpiar filtros",
                listView: "Lista",
                mapView: "Mapa",
                lastDay: "Último día",
                last10Days: "Últimos 10 días",
                lastMonth: "Último mes",
                lastQuarter: "Último trimestre",
                lastYear: "Último año",
                hideFilters: "Ocultar filtros",
                showFilters: "Mostrar filtros",
                loading: "Cargando...",
                errorFetching: "Error al obtener mascotas perdidas",
            },
            foundPetsPage: {
                title: "Mascotas Encontradas",
                reportFoundPet: "Mascota Encontrada",
                daysFound: "Encontrado hace {{count}} día/s",
                showOnlyMyPets: "Mostrar solo mis mascotas reportadas",
            },
            generalPet: {
                general: 'General',
                step1Title: 'Paso 1: Nombre, Sexo y Descripción de la Mascota',
                step2Title: 'Paso 2: Información General',
                step3Title: 'Paso 3: Comportamiento',
                step4Title: 'Paso 4: Información de Salud',
                nameRequired: 'El nombre es obligatorio',
                typeRequired: 'El tipo de mascota es obligatorio',
                genderRequired: 'El género es obligatorio',
                birthDateRequired: 'La fecha de nacimiento es obligatoria',
                breedRequired: 'La selección de raza es obligatoria',
                furRequired: 'La cantidad y longitud del pelaje son obligatorias cuando tiene pelaje',
                imageAvailable: 'No hay imagen disponible',
                petName: 'Nombre de la Mascota',
                petType: 'Tipo de Mascota',
                gender: 'Género',
                birthDate: 'Fecha de Nacimiento',
                noDescription: 'No hay descripción disponible.',
                breed: 'Raza',
                isMixedBreed: '¿Es de raza mixta?',
                breedSelection: 'Selección de Raza',
                selectBreedsOrUnknown: 'Seleccionar Razas o Desconocido',
                selectBreedOrUnknown: 'Seleccionar Raza o Desconocido',
                size: 'Tamaño',
                fur: 'Pelaje',
                hasFur: '¿Tiene pelaje?',
                noFur: 'Sin Pelaje',
                furAmount: 'Cantidad de Pelaje',
                furLength: 'Longitud del Pelaje',
                selectAmount: 'Seleccionar Cantidad',
                selectLength: 'Seleccionar Longitud',
                color: 'Color',
                primaryColor: 'Color Principal',
                secondaryColors: 'Colores Secundarios',
                selectColor: 'Seleccionar Color',
                eyeColors: 'Colores de Ojos',
                behaviorWithPeople: 'Comportamiento con Personas',
                behaviorWithDogs: 'Comportamiento con Perros',
                behaviorWithCats: 'Comportamiento con Gatos',
                behaviorWith: 'Comportamiento Con',
                withPeople: 'Personas',
                withDogs: 'Perros',
                withCats: 'Gatos',
                castrated: 'Castrado',
                isCastrated: '¿Está castrado el animal?',
                hasChip: '¿Tiene chip el animal?',
                chip: 'Chip',
                chipNumber: 'Número de Chip',
                noChip: 'No hay chip disponible',
                noChipNumber: 'No hay número de chip disponible',
                tattoo: 'Tatuaje',
                hasTattoo: '¿Tiene tatuaje el animal?',
                vaccines: 'Vacunas',
                noVaccines: 'No hay vacunas disponibles.',
                dewormings: 'Desparasitaciones',
                noDewormings: 'No hay desparasitaciones disponibles.',
                weight: 'Peso',
                fetchError: 'Error al obtener los datos de la mascota.',
                furRequired: 'La cantidad y longitud del pelaje son obligatorias cuando tiene pelaje',
                successMessageEdit: '¡Mascota actualizada con éxito!',
                errorMessageEdit: 'Error al actualizar la mascota',
                imageAvailable: "No hay imagen disponible",
                unknown: "Desconocido",
            },
        },
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: 'en', // Default language
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false, // React already escapes values
    },
});

export default i18n;